import { useGetAllOvertimePoliciesQuery } from '@/app/features/control-panel/policies/policies.api';
import CustomTable from '@/components/CustomTable';
import StatusTag from '@/components/StatusTag';
import { DISCLOSER_KEYS, FILTER_KEYS } from '@/constants/keys.constants';
import { useAppDiscloser, useAppFilters } from '@/hooks';
import { EyeIcon, PencilEdit02Icon } from '@/icons';
import type { ColumnsType } from '@/types/global.types';
import { minutesToHours, normalizeColumnValue } from '@/utils';
import { addUniqueKey } from '@/utils/global.utils';
import { Flex } from 'antd';
import ManageOvertimePolicy from './_components/Overtime/ManageOvertimePolicy';

const OVERTIME_STATUS_CONFIG = [
  { label: 'Active', value: 'active', className: 'status status-success' },
  { label: 'Inactive', value: 'inactive', className: 'status status-error' },
  { label: 'Draft', value: 'draft', className: 'status status-warning' },
];

const OverTime = () => {
  const { page, limit, filters, handlePagination } = useAppFilters(
    FILTER_KEYS.POLICIES_OVERTIME,
  );
  const [config, handleOpen, handleClose] = useAppDiscloser(
    DISCLOSER_KEYS.POLICIES_OVERTIME,
  );

  const {
    data: overtimePolicies,
    isLoading,
    isFetching,
  } = useGetAllOvertimePoliciesQuery({
    params: {
      ...filters,
      skip: (page - 1) * limit,
      take: limit,
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: 'Policy Name',
      dataIndex: 'policy_name',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Office',
      dataIndex: 'office_name',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Max Over Time Hour',
      dataIndex: 'max_overtime_minutes',
      render: (value: number) => `${minutesToHours(value)} Hr`,
    },
    {
      title: 'Per Hour Fixed Amount',
      dataIndex: 'per_hour_fixed_amount_bdt',
      render: (amount) => (amount ? `BDT ${amount}` : '0'),
    },
    {
      title: 'Over Time Rate Per Hour',
      dataIndex: 'overtime_rate_per_hour_percent',
      render: (value) => `${normalizeColumnValue(value, '0')} %`,
    },
    // {
    //   title: 'Overtime Rate',
    //   dataIndex: 'overtime_rate_per_hour_percent',
    //   render: () => normalizeColumnValue(0, '0'),
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (status: string) => (
        <StatusTag value={status} config={OVERTIME_STATUS_CONFIG} />
      ),
    },
    {
      width: 130,
      title: 'Action',
      render: (record) => (
        <Flex gap={11}>
          <button
            onClick={() => {
              handleOpen({ type: 'VIEW', data: record });
            }}
            className="cursor-pointer"
          >
            <EyeIcon size={20} className="text-white" />
          </button>
          <button
            onClick={() => handleOpen({ type: 'UPDATE', data: record })}
            className="cursor-pointer"
          >
            <PencilEdit02Icon size={20} className="text-white" />
          </button>
          {/* <button className="cursor-pointer">
            <CopyIcon className="text-white text-xl" />
          </button>
          <button className="cursor-pointer">
            <ArchiveArrowUpIcon className="text-white text-lg" />
          </button> */}
        </Flex>
      ),
    },
  ];

  return (
    <div>
      <CustomTable
        total={overtimePolicies?.data?.meta?.total || 0}
        page={page}
        limit={limit}
        hideRowSelect
        columns={columns}
        onPaginate={handlePagination}
        tableRootClassName="border-0 p-0"
        loading={isLoading || isFetching}
        dataSource={addUniqueKey(overtimePolicies?.data?.data || [])}
      />
      <ManageOvertimePolicy
        data={config.data}
        open={config.open}
        type={config.type}
        id={config?.data?.id}
        handleClose={handleClose}
      />
    </div>
  );
};

export default OverTime;
